import { Link } from "react-router-dom";

/**
 * Brand logo component. `variant="light"` uses the dark-on-white logo for
 * light backgrounds (default); `variant="dark"` uses the white-on-dark
 * reverse for dark backgrounds. `to` makes it a link to a route (omit to
 * render a plain image).
 */
export default function Logo({ variant = "light", to, className = "", size = "h-8", testId = "brand-logo" }) {
  const src = variant === "dark" ? "/logo-dark.png" : "/logo-light.png";
  const img = (
    <img
      src={src}
      alt="Auditor"
      className={`${size} w-auto select-none ${className}`}
      draggable={false}
      data-testid={testId}
    />
  );
  if (to) {
    return (
      <Link to={to} className="inline-flex items-center" aria-label="Auditor">
        {img}
      </Link>
    );
  }
  return img;
}
